/**
 * Saved while we override so arrow `ScrollToPlugin` tweens respect GSAP easing.
 * (`html { scroll-behavior: smooth }` makes `window.scrollTo()` ease in the
 * browser — GSAP's `ease: "none"` has no visible effect without this.)
 */
let scrollBehaviorRestore = null;

export function beginProgrammaticScroll() {
  endProgrammaticScroll();
  const html = document.documentElement;
  const body = document.body;
  scrollBehaviorRestore = {
    html,
    body,
    prevHtml: html.style.scrollBehavior,
    prevBody: body.style.scrollBehavior,
  };
  html.style.scrollBehavior = "auto";
  body.style.scrollBehavior = "auto";
}

export function endProgrammaticScroll() {
  if (!scrollBehaviorRestore) return;
  const { html, body, prevHtml, prevBody } = scrollBehaviorRestore;
  html.style.scrollBehavior = prevHtml;
  body.style.scrollBehavior = prevBody;
  scrollBehaviorRestore = null;
}

/**
 * Global `html { scroll-behavior: smooth }` also smooths programmatic scrolls.
 * After rewind we must jump to the pin start in one frame, or ScrollTrigger
 * progress eases 1→0 and replays the whole stage transition.
 */
export function scrollDocumentToYInstant(y) {
  const html = document.documentElement;
  const body = document.body;
  const prevHtml = html.style.scrollBehavior;
  const prevBody = body.style.scrollBehavior;
  html.style.scrollBehavior = "auto";
  body.style.scrollBehavior = "auto";
  try {
    window.scrollTo({ top: y, left: 0, behavior: "instant" });
  } catch {
    window.scrollTo(0, y);
  }
  requestAnimationFrame(() => {
    html.style.scrollBehavior = prevHtml;
    body.style.scrollBehavior = prevBody;
  });
}
